import React from 'react';
import './LoadingSpinnerElement.css'; // Import the CSS file

const LoadingSpinnerElement = () => {
  return <div style={{marginLeft:20, marginRight:20, marginTop:5}}className="spinner"></div>;
};

export default LoadingSpinnerElement;